export default [
  {
    "units" : {
      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "ppm" : "1",
      "cmolc/dm3" : "0.007143",
      "meq/L" : "0.07143",
      "mmol" : "0.0714",
      "%" : "0.0001",
      "meq/100cm3" : "0.007143",
      "mg/dm3" : "1",
      "cmol/kg" : "0.007143",
      "Kg/ha" : "2.4",
      "mg/l" : "1",
      "meq/100g" : "0.007143"
    },
    "types" : [
      {
        "label" : "N",
        "value" : 1
      },
      {
        "value" : 4.427,
        "label" : "NO3"
      },
      {
        "label" : "NH2",
        "value" : 1.142
      },
      {
        "label" : "NH4",
        "value" : 1.285
      }
    ],
    "key" : "N"
  },
  {
    "units" : {

      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "ppm" : "1",
      "cmolc/dm3" : "0.003229",
      "meq/L" : "0.03229",
      "mmol" : "0.03229",
      "%" : "0.0001",
      "meq/100cm3" : "0.003229",
      "mg/dm3" : "1",
      "cmol/kg" : "0.003229",
      "Kg/ha" : "2.4",
      "mg/l" : "1",
      "meq/100g" : "0.003229"
    },
    "types" : [
      {
        "value" : 1,
        "label" : "P"
      },
      {
        "value" : 3.066,
        "label" : "PO4"
      },
      {
        "value" : 2.291,
        "label" : "P2O5"
      },
      {
        "label" : "H2PO4",
        "value" : 3.129
      }
    ],
    "key" : "P"
  },
  {
    "units" : {
      "cmol/kg" : "0.002564",
      "meq/100cm3" : "0.002564",
      "mg/dm3" : "1",
      "meq/100g" : "0.002564",
      "mg/l" : "1",
      "Kg/ha" : "2.4",
      "ppm" : "1",
      "mg/kg" : "1",
      "lb/acre" : "2.14123",
      "meq/L" : "0.02564",
      "%" : "0.0001",
      "mmol" : "0.02564",
      "cmolc/dm3" : "0.002564"
    },
    "key" : "K",
    "types" : [
      {
        "value" : 1,
        "label" : "K"
      },
      {
        "value" : 1.205,
        "label" : "K2O"
      }
    ]
  },
  {
    "units" : {
      "cmolc/dm3" : "0.005",
      "mmol" : "0.025",
      "%" : "0.0001",
      "meq/L" : "0.05",
      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "ppm" : "1",
      "Kg/ha" : "2.4",
      "mg/l" : "1",
      "meq/100g" : "0.005",
      "mg/dm3" : "1",
      "meq/100cm3" : "0.005",
      "cmol/kg" : "0.005"
    },
    "key" : "Ca",
    "types" : [
      {
        "value" : 1,
        "label" : "Ca"
      },
      {
        "value" : 1.394,
        "label" : "CaO"
      },
      {
        "label" : "CaCO3",
        "value" : 2.5
      }
    ]
  },
  {
    "units" : {
      "cmol/kg" : "0.00833",
      "mg/dm3" : "1",
      "meq/100cm3" : "0.00833",
      "meq/100g" : "0.00833",
      "mg/l" : "1",
      "Kg/ha" : "2.4",
      "ppm" : "1",
      "mg/kg" : "1",
      "lb/acre" : "2.14123",
      "%" : "0.0001",
      "mmol" : "0.04167",
      "meq/L" : "0.0833",
      "cmolc/dm3" : "0.00833"
    },
    "types" : [
      {
        "value" : 1,
        "label" : "Mg"
      },
      {
        "label" : "MgO",
        "value" : 1.657
      },
      {
        "value" : 4.1667,
        "label" : "MgCO3"
      }
    ],
    "key" : "Mg"
  },
  {
    "units" : {
      "meq/100g" : "0.00625",
      "mg/l" : "1",
      "Kg/ha" : "2.4",
      "cmol/kg" : "0.00625",
      "mg/dm3" : "1",
      "meq/100cm3" : "0.00625",
      "%" : "0.0001",
      "mmol" : "0.03125",
      "meq/L" : "0.0625",
      "cmolc/dm3" : "0.00625",
      "ppm" : "1",
      "mg/kg" : "1",
      "lb/acre" : "2.14123"
    },
    "key" : "S",
    "types" : [
      {
        "label" : "S",
        "value" : 1
      },
      {
        "value" : 3,
        "label" : "SO4"
      }
    ]
  },
  {
    "key" : "NNO3",
    "n_form": true,
    "types" : [
      {
        "label" : "NNO3",
        "value" : 1
      },
      {
        "value" : 4.427,
        "label" : "NO3"
      }
    ],
    "units" : {
      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "ppm" : "1",
      "cmolc/dm3" : "0.007143",
      "meq/L" : "0.07143",
      "mmol" : "0.0714",
      "%" : "0.0001",
      "meq/100cm3" : "0.007143",
      "mg/dm3" : "1",
      "cmol/kg" : "0.007143",
      "Kg/ha" : "2.4",
      "mg/l" : "1",
      "meq/100g" : "0.007143"
    }
  },
  {
    "key" : "NNH2",
    "n_form": true,
    "types": [
      {
        "value" : 1,
        "label" : "NNH2"
      },
      {
        "value" : 1.142,
        "label" : "NH2"
      }
    ],
    "units" : {
      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "ppm" : "1",
      "cmolc/dm3" : "0.007143",
      "meq/L" : "0.07143",
      "mmol" : "0.0714",
      "%" : "0.0001",
      "meq/100cm3" : "0.007143",
      "mg/dm3" : "1",
      "cmol/kg" : "0.007143",
      "Kg/ha" : "2.4",
      "mg/l" : "1",
      "meq/100g" : "0.007143"
    }
  },
  {
    "types": [
      {
        "value" : 1,
        "label" : "NNH4"
      },
      {
        "value" : 1.285,
        "label" : "NH4"
      }
    ],
    "key" : "NNH4",
    "units" : {
      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "ppm" : "1",
      "cmolc/dm3" : "0.007143",
      "meq/L" : "0.07143",
      "mmol" : "0.0714",
      "%" : "0.0001",
      "meq/100cm3" : "0.007143",
      "mg/dm3" : "1",
      "cmol/kg" : "0.007143",
      "Kg/ha" : "2.4",
      "mg/l" : "1",
      "meq/100g" : "0.007143"
    },
    "n_form": true
  },
  {
    "label" : "B",
    "key" : "B",
    "units" : {
      "meq/L" : "0.185",
      "%" : "0.0001",
      "mmol" : "0.092498",
      "cmolc/dm3" : "0.0185",
      "ppm" : "1",
      "mg/kg" : "1",
      "lb/acre" : "2.14123",
      "meq/100g" : "0.0185",
      "mg/l" : "1",
      "Kg/ha" : "2.4",
      "cmol/kg" : "0.0185",
      "meq/100cm3" : "0.0185",
      "mg/dm3" : "1"
    }
  },
  {
    "label" : "Fe",
    "units" : {
      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "ppm" : "1",
      "cmolc/dm3" : "0.0035813",
      "meq/L" : "0.035813",
      "mmol" : "0.017907",
      "%" : "0.0001",
      "meq/100cm3" : "0.0035813",
      "mg/dm3" : "1",
      "cmol/kg" : "0.0035813",
      "Kg/ha" : "2.4",
      "mg/l" : "1",
      "meq/100g" : "0.0035813"
    },
    "key" : "Fe"
  },
  {
    "units" : {
      "ppm" : "1",
      "mg/kg" : "1",
      "lb/acre" : "2.14123",
      "meq/L" : "0.036405",
      "%" : "0.0001",
      "mmol" : "0.018202",
      "cmolc/dm3" : "0.0036405",
      "cmol/kg" : "0.0036405",
      "meq/100cm3" : "0.0036405",
      "mg/dm3" : "1",
      "meq/100g" : "0.0036405",
      "mg/l" : "1",
      "Kg/ha" : "2.4"
    },
    "key" : "Mn",
    "label" : "Mn"
  },
  {
    "label" : "Zn",
    "key" : "Zn",
    "units" : {
      "Kg/ha" : "2.4",
      "mg/l" : "1",
      "meq/100g" : "0.003059",
      "meq/100cm3" : "0.003059",
      "mg/dm3" : "1",
      "cmol/kg" : "0.003059",
      "cmolc/dm3" : "0.003059",
      "meq/L" : "0.03059",
      "mmol" : "0.015295",
      "%" : "0.0001",
      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "ppm" : "1"
    }
  },
  {
    "key" : "Cu",
    "units" : {
      "cmol/kg" : "0.0031473",
      "meq/100cm3" : "0.0031473",
      "mg/dm3" : "1",
      "meq/100g" : "0.0031473",
      "mg/l" : "1",
      "Kg/ha" : "2.4",
      "ppm" : "1",
      "mg/kg" : "1",
      "lb/acre" : "2.14123",
      "meq/L" : "0.031473",
      "%" : "0.0001",
      "mmol" : "0.015737",
      "cmolc/dm3" : "0.0031473"
    },
    "label" : "Cu"
  },
  {
    "units" : {
      "mg/kg" : "1",
      "lb/acre" : "2.14123",
      "ppm" : "1",
      "cmolc/dm3" : "0.0020846",
      "meq/L" : "0.020846",
      "%" : "0.0001",
      "mmol" : "0.010423",
      "meq/100cm3" : "0.0020846",
      "mg/dm3" : "1",
      "cmol/kg" : "0.0020846",
      "Kg/ha" : "2.4",
      "meq/100g" : "0.0020846",
      "mg/l" : "1"
    },
    "key" : "Mo",
    "label" : "Mo"
  },
  {
    "units" : {
      "cmol/kg" : "0.00435",
      "mg/dm3" : "1",
      "meq/100cm3" : "0.00435",
      "mg/l" : "1",
      "meq/100g" : "0.00435",
      "Kg/ha" : "2.4",
      "ppm" : "1",
      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "mmol" : "0.0435",
      "%" : "0.0001",
      "meq/L" : "0.0435",
      "cmolc/dm3" : "0.00435"
    },
    "key" : "Na",
    "label" : "Na"
  },
  {
    "key" : "HCO3",
    "units" : {
      "ppm" : "1",
      "lb/acre" : "2.14123",
      "mg/kg" : "1",
      "mg/dm3" : "1",
      "meq/L" : "0.01639",
      "mg/l" : "1",
      "mmol" : "0.01639",
      "%" : "0.0001",
      "Kg/ha" : "2.4"
    },
    "label" : "HCO3"
  },
  {
    "key" : "Cl",
    "units" : {
      "meq/L" : "0.02821",
      "%" : "0.0001",
      "mmol" : "0.02821",
      "cmolc/dm3" : "0.002821",
      "ppm" : "1",
      "mg/kg" : "1",
      "lb/acre" : "2.14123",
      "meq/100g" : "0.002821",
      "mg/l" : "1",
      "Kg/ha" : "2.4",
      "cmol/kg" : "0.002821",
      "meq/100cm3" : "0.002821",
      "mg/dm3" : "1"
    },
    "label" : "Cl"
  },
  {
    "label" : "Al",
    "key" : "Al",
    "units": {
      "ppm": 1
    }
  }
]
